
const FORTUNE_KEY = 'fortune_timestamp';
const FORTUNE_COUNT_KEY = 'fortune_count';
const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;

export const canGetFortune = (): boolean => {
  const lastTimestamp = localStorage.getItem(FORTUNE_KEY);
  const fortuneCount = Number(localStorage.getItem(FORTUNE_COUNT_KEY) || '0');
  
  // If no timestamp or it's a new day, allow getting a fortune
  if (!lastTimestamp) {
    return true;
  }
  
  const lastDate = new Date(Number(lastTimestamp));
  const currentDate = new Date();
  
  // Check if it's a new day (different date)
  if (
    lastDate.getDate() !== currentDate.getDate() ||
    lastDate.getMonth() !== currentDate.getMonth() ||
    lastDate.getFullYear() !== currentDate.getFullYear()
  ) {
    // Reset count for new day
    localStorage.setItem(FORTUNE_COUNT_KEY, '0');
    return true;
  }
  
  // If on same day, check if user has used their free fortune
  return fortuneCount < 1;
};

export const recordFortune = (): void => {
  const currentTimestamp = Date.now();
  localStorage.setItem(FORTUNE_KEY, currentTimestamp.toString());
  
  const currentCount = Number(localStorage.getItem(FORTUNE_COUNT_KEY) || '0');
  localStorage.setItem(FORTUNE_COUNT_KEY, (currentCount + 1).toString());
};

export const recordAdWatched = (): void => {
  // This would decrease the count by 1 to allow another fortune
  const currentCount = Number(localStorage.getItem(FORTUNE_COUNT_KEY) || '0');
  if (currentCount > 0) {
    localStorage.setItem(FORTUNE_COUNT_KEY, (currentCount - 1).toString());
  }
};

export const getTimeUntilNextFortune = (): string => {
  const lastTimestamp = localStorage.getItem(FORTUNE_KEY);
  
  if (!lastTimestamp) {
    return 'now';
  }
  
  const lastTime = Number(lastTimestamp);
  const nextResetTime = new Date(lastTime);
  nextResetTime.setHours(0, 0, 0, 0);
  nextResetTime.setDate(nextResetTime.getDate() + 1);
  
  const timeRemaining = nextResetTime.getTime() - Date.now();
  
  if (timeRemaining <= 0) {
    return 'now';
  }
  
  const hours = Math.floor(timeRemaining / (60 * 60 * 1000));
  const minutes = Math.floor((timeRemaining % (60 * 60 * 1000)) / (60 * 1000));
  
  if (hours > 0) {
    return `${hours}h ${minutes}m`;
  } else {
    return `${minutes}m`;
  }
};
